import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import {
  DeployPayload,
  RuntimeDispatch,
  runDeployErrorEffects,
  runDeploySuccessEffects
} from './deployMutationEffects';

import api from '~/api/runtime';

export function useRedeployDeploy() {
  const dispatch = useDispatch() as unknown as RuntimeDispatch;

  const mutation = useMutation({
    mutationFn: (payload: DeployPayload) => api.redeploy(payload),
    onSuccess: (_data, payload) => runDeploySuccessEffects(dispatch, payload),
    onError: error => runDeployErrorEffects(dispatch, error)
  });

  return {
    redeployDeploy: mutation.mutateAsync,
    redeploying: mutation.isPending
  };
}
